import axios, { CreateAxiosDefaults } from "axios";
import { API_URL } from "@src/config";

const initializeAxiosOptions = () => {
  const options: CreateAxiosDefaults = {
    baseURL: API_URL,
    paramsSerializer: {
      serialize: (params: any) => {
        const paramsCopy = { ...params };
        Object.keys(paramsCopy).forEach(
          (key) => paramsCopy[key] === undefined && delete paramsCopy[key]
        );

        return new URLSearchParams(paramsCopy).toString();
      },
    },
  };

  // TODO: in future if we need to send token in request uncomment this
  // const rawTokenData = localStorage.getItem(LS_TOKEN_KEY);

  // if (rawTokenData) {
  //   const tokenData: TokenData = JSON.parse(rawTokenData);
  //   if (tokenData.access_token) {
  //     options.headers = {
  //       common: { Authorization: `Bearer ${tokenData.access_token}` },
  //     };
  //   }
  // }

  return options;
};

export { initializeAxiosOptions };

export const api = axios.create(initializeAxiosOptions());
